import React from "react";

import Dashboard from "./dashboard";

import {DateRangePickerContextProvider} from "contexts/DateRangePickerContext";

export default function Index() {
    return (
        <DateRangePickerContextProvider>
            <Dashboard />
        </DateRangePickerContextProvider>
    )
}
